import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { BREAKPOINTS } from '@/styles/themes/default';

import { LiveButton, slideToLeft, delayedAnimation } from './shared';

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  min-height: 350px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    min-height: 400px;
  }
`;

const BaseImage = styled.img`
  position: absolute;
  z-index: 1;
  left: 100%;
  height: auto;
  max-width: 205px;
  top: 20px;
  padding: 0;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    margin-left: 20px;
    max-width: 230px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    padding: 0 20px;
    margin-left: 30px;
    max-width: 270px;
  }
`;

const liveButtonInitialStyles = css`
  position: absolute;
  z-index: 2;
  left: 100%;
  top: 0;
`;

const GraphImage = styled.img`
  position: absolute;
  z-index: 3;
  left: 100%;
  top: 100px;
  max-width: 180px;
  margin-left: 110px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    max-width: 216px;
    margin-left: 170px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    max-width: 245px;
    margin-left: 220px;
  }
`;

export const Posters = () => {
  return (
    <Wrapper>
      <BaseImage css={slideToLeft} src="/images/landing/eventExample/posters-base.jpg" alt="posters example" />
      <LiveButton css={[slideToLeft, liveButtonInitialStyles, delayedAnimation(0.7)]} label="live Q&A" />
      <GraphImage
        css={[slideToLeft, delayedAnimation(1.1)]}
        src="/images/landing/eventExample/posters-graphs.jpg"
        alt="posters comment example"
      />
    </Wrapper>
  );
};
